package com.essntl.features.itinerary.domain.model

import com.essntl.config.EssntlConfig

val ItineraryModel.shareLink
    get() =
        shareCode?.let {
            "${EssntlConfig.essntlBaseUrl}/i/$it"
        }


fun ItineraryModel.servicesToConfirmText(services: List<ItineraryServiceModel>): String {
    val notConfirmedServices = services.filter {
        it.status != ItineraryServiceModel.Status.Confirmed &&
            it.status != ItineraryServiceModel.Status.Cancelled
    }

    return if (notConfirmedServices.isNotEmpty()) {
        "${notConfirmedServices.count()} of ${services.count()} not confirmed"
    } else {
        "All services confirmed     🙌"
    }
}

fun ItineraryToConfirmModel.servicesToConfirmText(): String {
    return if (unconfirmedServiceCount != 0) {
        "$unconfirmedServiceCount of $totalServices not confirmed"
    } else {
        "All services confirmed 🙌"
    }
}